export { ORGANIZATION_STATUS } from '@folio/plugin-find-organization';

export const DICT_CATEGORIES = 'vendorCategories';
